import { Typography, useTheme } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import * as React from 'react';

import { agentHeaderStyles } from './agent-page.styles';
import { ConversationDropdown } from './conversation-dropdown';

interface AgentHeaderProps {
    headerActions?: React.ReactNode;
    showIntro?: boolean;
    variant?: 'page' | 'sidebar';
}

export const AgentHeader: React.FC<AgentHeaderProps> = ({ headerActions, showIntro, variant = 'page' }) => {
    const theme = useTheme<Theme>();
    const headerActionsNode = headerActions ? <div className="agent__headerActions">{headerActions}</div> : null;

    const brandContent =
        variant === 'sidebar' ? (
            <ConversationDropdown />
        ) : (
            <Typography variant="subtitle1" className="agent__headerTitle">
                Orbit
            </Typography>
        );

    return (
        <header css={agentHeaderStyles(theme)} className="agent__header">
            <div className="agent__headerBrand">
                <img
                    src="/images/orbit-transparent-small.png"
                    alt="Orbit logo"
                    className={`agent__logo${showIntro ? ' is-hidden' : ''}`}
                />
                {brandContent}
            </div>
            {headerActionsNode}
        </header>
    );
};
